document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("rentalSubmitBtn");
  const form = document.getElementById("rentalShippingForm");

  // If section isn't present on the current page, do nothing
  if (!btn || !form) return;

  // Safer way to access fields by name
  const getField = (name) => form.elements.namedItem(name);

  // Helper: Show error message below field
  function showError(field, message) {
    if (!field) return;

    field.classList.add("error");

    let errorEl = field.nextElementSibling;
    if (!errorEl || !errorEl.classList.contains("error-message")) {
      errorEl = document.createElement("div");
      errorEl.className = "error-message";
      field.insertAdjacentElement("afterend", errorEl);
    }

    errorEl.innerText = message;
  }

  // Helper: Clear error
  function clearError(field) {
    if (!field) return;

    field.classList.remove("error");
    const errorEl = field.nextElementSibling;
    if (errorEl && errorEl.classList.contains("error-message")) {
      errorEl.remove();
    }
  }

  // Helper to clear all errors
  function clearAllErrors() {
    document.querySelectorAll(".error-message").forEach((el) => el.remove());
    document.querySelectorAll(".error").forEach((el) => el.classList.remove("error"));
  }

  // Validate all required fields
  function validateForm() {
    let isValid = true;

    const requiredFields = [
      "email",
      "first_name",
      "last_name",
      "address1",
      "city",
      "postcode",
      "phone"
    ];

    requiredFields.forEach((name) => {
      const field = getField(name);
      clearError(field);

      const value = String(field?.value || "").trim();
      if (!value) {
        showError(field, "This field is required");
        isValid = false;
      }
    });

    // Email format check
    const emailField = getField("email");
    const email = String(emailField?.value || "").trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(emailField, "Please enter a valid email");
      isValid = false;
    }

    // UK Postcode validation
    const postcodeField = getField("postcode");
    const postcode = String(postcodeField?.value || "").trim().toUpperCase();
    const postcodeRegex =
      /^([Gg][Ii][Rr] 0[Aa]{2}|(?![Qq][Vv][Xx])[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][A-Za-z]{2})$/;

    if (postcode && !postcodeRegex.test(postcode)) {
      showError(postcodeField, "Enter a valid UK postcode (e.g. SW1A 1AA)");
      isValid = false;
    }

    // UK Phone Validation (landline + mobile)
    const phoneField = getField("phone");
    const phone = String(phoneField?.value || "").trim();
    const phoneRegex = /^(?:0|\+44)(?:\s?\d){10}$/;

    if (phone && !phoneRegex.test(phone)) {
      showError(phoneField, "Enter a valid UK phone number");
      isValid = false;
    }

    return isValid;
  }

  btn.addEventListener("click", async () => {
    clearAllErrors();

    const originalText = btn.innerText || "Continue";

    if (!validateForm()) {
      btn.disabled = false;
      btn.innerText = originalText;
      return;
    }

    // Disable button + change text
    btn.disabled = true;
    btn.innerText = "Processing...";

    const qs = new URLSearchParams(window.location.search);

    // Optional: enforce presence of variant_id
    const variantId = qs.get("variant_id");
    if (!variantId) {
      alert("Missing variant_id in the page URL.");
      btn.disabled = false;
      btn.innerText = originalText;
      return;
    }

    const payload = {
      email: String(getField("email")?.value || "").trim(),
      first_name: String(getField("first_name")?.value || "").trim(),
      last_name: String(getField("last_name")?.value || "").trim(),
      product_variant_id: variantId,
      product_details: {
        product_name: qs.get("product_name"),
        variant_name: qs.get("variant_name"),
        price: qs.get("price")
      },
      address: {
        line1: String(getField("address1")?.value || "").trim(),
        line2: String(getField("address2")?.value || "").trim() || null,
        city: String(getField("city")?.value || "").trim(),
        country: "GB",
        postal_code: String(getField("postcode")?.value || "").trim()
      },
      phone: String(getField("phone")?.value || "").trim()
    };

    try {
      const response = await fetch("https://app.gonoknok.com/rental/create-draft-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });

      // Don’t assume JSON always returns valid JSON on errors
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || "Request failed");
      }

      if (data.success && data.redirect_url) {
        // Ensure absolute URL to reduce redirect edge cases
        try {
          const redirectUrl = new URL(data.redirect_url, window.location.origin).toString();
          window.top.location.href = redirectUrl;
        } catch {
          window.top.location.href = data.redirect_url;
        }
        return;
      }

      alert("Order created but redirect failed. Please contact support.");
    } catch (err) {
      alert(err?.message || String(err));
    } finally {
      btn.disabled = false;
      btn.innerText = originalText;
    }
  });
});
